export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_OCRA-120X120.6d1aad30.jpg";